import React, { useEffect } from 'react';
import iconoEventos from '../assets/eventos.png';
import imagenPerfil from '../assets/rubros/imagen_dura.jpg';
import iconoEmpresas from '../assets/empresas.png';
import iconoActividades from '../assets/actividades.png';
import flecha from '../assets/flechaPaginacion.png';
import '../css/navBar.css';
import { cerrarSesion } from '../funciones.js';
import { ItemNavBarAdmin } from './ItemNavBarAdmin';
import salir from '../assets/salida.png';

export const NavBarAdmin2 = ({ itemsNavBar }) => {


    useEffect(() => {
        let url = window.location.pathname;

        itemsNavBar.forEach(e => {
            if (!url.localeCompare(e.url)) {
                setActive(e.id);

            }
        });

        function setActive(id) {
            document.getElementById(id).classList.add("menuAdminActivo");
        }
    }, [])

    function mostrarMenu() {
        document.getElementById("navBar").classList.toggle("mostrar");
    }
    function mostrarMenuMobile() {
        document.getElementById("colNavBar").classList.toggle("mostrarMenu");
        document.getElementById("hamburger").classList.toggle("open");
    }
    return (
        <>
            <div class="nav-link d-none p-3 fw-800  cursor-pointer flex-no-wrap transition-all-1s 
            mostrarMenuAdmin" onClick={mostrarMenuMobile}>{/* ms-2 px-sm-3
                <div className='navbar-toggler-icon-black navbar-toggler-icon ' alt="" />*/}
                <div id="hamburger" className='centrarContainer'>
                    <button className='mx-auto '>
                        <span className='top-line bg-black'></span>
                        <span className='middle-line bg-black'></span>
                        <span className='bottom-line bg-black'></span>
                    </button>
                </div>
            </div>
            <nav id="navBar" class=" d-block textoTablas position-relative h-100 menuMobileAdmin transition-all-1s">

                <div class=" dropdown-toggle  centrarContainer  flex-no-wrap px-3 ms-2 py-4 ">
                    <img id="imagenPerfil" className='me-4 rounded-circle' src={imagenPerfil} alt="" />
                    {/*<div>
                    <div id="imagenPerfil" className='me-4 rounded-circle centrarContainer' alt="" >
                        <div className='text-white text-center w-100 '>A</div>
                    </div></div>*/}
                    <div id="nombrePerfilNavBar" className='letraTituloPerfil text-nav'>Administrador</div>
                </div>

                <div class="nav-link  py-3 px-3 fw-800 centrarContainer cursor-pointer flex-no-wrap" title='Menú' onClick={mostrarMenu}>{/* ms-2 px-sm-3*/}
                    <div className='centrarContainer'><div className='me-4 ms-2 navbar-toggler-icon-black navbar-toggler-icon' alt="" /></div>
                    <div className='text-nav d-inline-block'>Menú</div>
                </div>
                {itemsNavBar.map(function (elem) {
                    return (
                        <ItemNavBarAdmin id={elem.id} nombre={elem.nombre} url={elem.url} logo={elem.logo} />
                    )
                })}
                <div class="cerrarSesionAdmin cursor-pointer text-no-wrap" href="#" onClick={() => cerrarSesion(true)}>
                    <img src={salir} className='me-4 mb-1 imgCerrar img-rojo' title='Cerrar sesión' alt="" />
                    <div className='text-nav d-inline-block'>Cerrar sesión</div>
                </div>
                {/*<div className='container position-fixed bottom-0 end-0 start-0  navbarMobile d-none'>
                    <div className='row text-center w-100 mx-auto'>
                        <div className='col  py-3'>
                            <a class="nav-link text-white px-0" aria-current="page" href="/">
                                <img className='mb-1 imagenNavPerfil' src={iconoEventos} alt="" />
                                <div>Crear evento</div>
                            </a>
                        </div>
                        <div className='col  py-3'>
                            <a class="nav-link text-white px-0" aria-current="page" href="/empresas">
                                <img className='mb-1 imagenNavPerfil' src={iconoEmpresas} alt="" />
                                <div>Empresas</div>
                            </a>
                        </div>
                        <div className='col  py-3'>
                            <a class="nav-link text-white px-0" aria-current="page" href="/reuniones">
                                <img className='mb-1 imagenNavPerfil' src={iconoActividades} alt="" />
                                <div>Reuniones</div>
                            </a>
                        </div>
                        {/*<div className='col py-3'>
                            <a class="nav-link text-white px-0" aria-current="page" href="/" data-bs-toggle="modal" data-bs-target="#modalMiPerfil">
                                <img className='mb-1 imagenNavPerfil' src={iconoPerfil} alt="" />
                                <div>Perfil</div>
                            </a>
                        </div>* /}
                    </div>
                </div>*/}
            </nav>

        </>
    );
}


